<script lang="ts" setup>
import PhIcon from '../PhIcon.vue'
import LabelBase from '../label/LabelBase.vue'

withDefaults(
  defineProps<{
    iconName?: string
    animation?: string
  }>(),
  {
    iconName: 'circle-notch',
    animation: 'animate-spin',
  },
)
</script>

<template>
  <div class="flex flex-col py-8">
    <div :class="animation" class="mx-auto">
      <ph-icon :name="iconName" :size="64"></ph-icon>
    </div>
    <label-base size="xl" class="block mx-auto font-bold">Loading...</label-base>
    <label-base class="block text-stone-500 mx-auto"
      >Sedang mengirim/memuat data, mohon ditunggu...</label-base
    >
  </div>
</template>
